export default {"src":"/_next/static/media/facebook.9c51623e.svg","height":16,"width":16};